<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Bank Card {{ (bankCard.name) ? (" - " + bankCard.name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">{{this.$attrs.viewMode == true ? "View" : "Edit"}} Bank Card - {{bankCard.name}}</h6>
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode != 2">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="bankCard.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="bankCard.name" input-classes="form-control" required />

                        <base-input label="Bank">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="bankName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Banks"
                                        :source="banksEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getBank">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="bankCard.remark" />
                        </base-input>

                        <hr><h4>Bank Card Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isBankCard">
                            Bank Card
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEpsCard">
                            EPS Card
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEwalletCard">
                            E-Wallet Card
                        </base-checkbox>
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane tab="Card Swipe Codes" key="2" forceRender>
                        <base-input alternative="" label="MSR Code">
                            <a-select mode="tags" style="width: 100%" :disabled="this.$attrs.viewMode == true" v-model="bankCard.msr_codes" placeholder="Input MSR Code">
                            </a-select>
                        </base-input>
                    </a-tab-pane>

                    <a-tab-pane v-if="customFormMode == 3" tab="Custom Fields" key="3" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="bankCard" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        <!-- <base-input alternative="" label="MSR Code" placeholder="" v-model="inputMsrCode" input-classes="form-control" required /> -->
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-else>
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="bankCard" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
            <!-- <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div> -->
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import { mapState } from 'vuex'
    import Autocomplete from 'vuejs-auto-complete'
    import DynamicForm from '../DynamicForm.vue'
    
    var component_x;
    export default {
        components: {
            Autocomplete,
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Bank Card?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            // alert(this.customFormMode);

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var bank_card_data = await HTTPRequest.getRequest(component_x.endPoint + 'bank_cards/' + component_x.profileId, null)
                if (bank_card_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (bank_card_data["error"] == undefined) {
                        component_x.bankCard = bank_card_data
                        // component_x.inputName = bank_card_data["name"]
                        // component_x.inputCode = bank_card_data["code"]
                        // component_x.inputRemark = bank_card_data["remark"]
                        component_x.checkboxes.isBankCard = bank_card_data["is_bank_card"]
                        component_x.checkboxes.isEpsCard = bank_card_data["is_eps_card"]
                        component_x.checkboxes.isEwalletCard = bank_card_data["is_ewallet_card"]
                        // component_x.inputBank = bank_card_data["bank_id"]
                        component_x.bankName = bank_card_data["bank_name"]
                        component_x.inputMsrCode = bank_card_data["msr_codes"]
                    } else {
                        this.errors = bank_card_data["error"].split(",")
                    }
                }
            }

            // To handle update on dynamic forms on load
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                checkboxes: {
                    isBankCard: false,
                    isEpsCard: false,
                    isEwalletCard: false
                },
                inputBank: null,
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
                bankName: '',
                errors: [],

                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                bankCard: {
                    name: '',
                    code: '',
                    msr_codes: []
                },
                formErrors: []
            }
        },
        methods: {
            // meta-data functions
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bankCard
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.bankCard = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            banksEndpoint(input) {
                return this.endPoint + '/banks?name=' + input
            },
            getBank(group) {
                this.bankName = group.display
                this.bankCard.bank_id = group.value
            },
            formattedDisplay(result) {
                return result.name + ' [' + result.code + ']'
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.bankCard.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.bankCard.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.bankCard.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.bankCard.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.bankCard.name, 0, 50));

                // if(this.bankCard.msr_codes.length == 0){
                //     this.errors.push("MSR Code is required atleast one")
                // }
                
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {

                if(!this.validateForm()) {
                    
                    Object.assign(this.bankCard, {
                        name: this.bankCard.name.trim(),
                        code: this.bankCard.code.trim(),
                        is_bank_card: this.checkboxes.isBankCard,
                        is_eps_card: this.checkboxes.isEpsCard,
                        is_ewallet_card: this.checkboxes.isEwalletCard 
                    })

                    var bank_cardPayload = { bank_card: this.bankCard }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'bank_cards', null, bank_cardPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    Object.assign(this.bankCard, {
                        name: this.bankCard.name.trim(),
                        code: this.bankCard.code.trim(),
                        is_bank_card: this.checkboxes.isBankCard,
                        is_eps_card: this.checkboxes.isEpsCard,
                        is_ewallet_card: this.checkboxes.isEwalletCard
                    })

                    var bank_cardPayload = { bank_card: this.bankCard }
                    
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'bank_cards/' + this.profileId, null, bank_cardPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>